
import { Pagination, Navigation } from "swiper";

export default {
  props: {
    images: { type: Array, required: true },
    getImageOptions: { type: Function, default: () => {} },
    /** When two PDP galleries mount (desktop + mobile), each needs a unique Swiper selector */
    instanceKey: { type: String, default: "" },
  },

  data: () => ({ swiper: null }),

  computed: {
    swiperRootClasses() {
      return [
        "swiper",
        "overflow-x-hidden",
        "w-full",
        "relative",
        "pdp-image",
        `pdp-image--${this.instanceKey}`,
      ];
    },
    swiperInitSelector() {
      return `.swiper.pdp-image--${this.instanceKey}`;
    },
    prevNavUniqueClass() {
      return `pdp-image-nav-prev--${this.instanceKey}`;
    },
    nextNavUniqueClass() {
      return `pdp-image-nav-next--${this.instanceKey}`;
    },
    paginationUniqueClass() {
      return `pdp-image-swiper-pagination--${this.instanceKey}`;
    },
    paginationSelector() {
      return `.pdp-image-swiper-pagination--${this.instanceKey}`;
    },
    swiperOptions() {
      return {
        autoHeight: false,
        slidesPerGroup: 1,
        slidesPerView: "auto",
        loop: true,
        preventClicks: false,
        preventClicksPropagation: false,
        modules: [Navigation, Pagination],
        navigation: {
          nextEl: `.${this.nextNavUniqueClass}`,
          prevEl: `.${this.prevNavUniqueClass}`,
        },
        pagination: {
          el: this.paginationSelector,
          clickable: true,
          renderBullet: (index, className) =>
            `<span class="${className}">&nbsp;&nbsp;</span>`,
        },
      };
    },
  },

  async mounted() {
    await this.$swiper.init(this.swiperInitSelector, this.swiperOptions);
  },

  destroyed() {
    this.$swiper.destroy(this.swiperInitSelector);
  },

  methods: {
    handleImageClick(event) {
      const slide = event.target.closest(".swiper-slide");
      if (!slide) return;

      const index = Number(slide.dataset.index);
      if (!Number.isNaN(index)) {
        this.$emit("image-click", index);
      }
    },
  },
};
